import { render, staticRenderFns } from "./UserEditAuthorization.vue?vue&type=template&id=6d768abe&scoped=true&"
import script from "./UserEditAuthorization.vue?vue&type=script&lang=js&"
export * from "./UserEditAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./UserEditAuthorization.vue?vue&type=style&index=0&id=6d768abe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d768abe",
  null
  
)

export default component.exports